import { render, staticRenderFns } from "./ChannelInfoColumn.vue?vue&type=template&id=3a062dcc&scoped=true&"
import script from "./ChannelInfoColumn.vue?vue&type=script&lang=js&"
export * from "./ChannelInfoColumn.vue?vue&type=script&lang=js&"
import style0 from "./ChannelInfoColumn.vue?vue&type=style&index=0&id=3a062dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a062dcc",
  null
  
)

export default component.exports